<template>
  <Main>
    <InvoiceForm :form="form" @submit="submit" @cancel="previousPage()" />
    <ModalGenericCriticism
      v-model="modal"
      @close="closeSubmitModal"
      title="FATURA GERADA"
      text="A fatura foi gerada com sucesso"
    />
    <ModalCancelInsurance
      @close="closeModal"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import InvoiceForm from "../components/InvoiceForm";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapActions } from "vuex";
import PolicyMixin from "@/mixins/PolicyMixin";
import ModalCancelInsurance from "../../insurance_company/components/ModalCancelInsurance";
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancel = true;
    this.nextRoute = to;
    if (this.cancel) next();
  },
  data: () => ({
    form: {
      documentos: [],
      boletos: [],
      arquivo: null
    },
    modal: false,
    modalCancel: false,
    nextRoute: null,
    cancel: false
  }),
  components: {
    InvoiceForm,
    ModalGenericCriticism,
    ModalCancelInsurance
  },
  mixins: [LoadingRequest, PolicyMixin],
  created() {
    this.withLoading(this.requestListInsuranceCompany());
  },
  methods: {
    ...mapActions("policy", [
      "requestNewInvoice",
      "requestListInsuranceCompany"
    ]),
    async submit(form) {
      this.withLoading(
        this.requestNewInvoice(await this.getPayloadInvoice(form)).then(() => {
          this.modal = true;
        })
      );
    },
    previousPage() {
      this.$router.push({ name: "policy", params: { currentTab: 1 } });
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({
          name: this.nextRoute.name,
          params: this.nextRoute.params
        });
      }
    },
    closeSubmitModal() {
      this.modal = false;
      this.cancel = true;
      this.previousPage();
    }
  }
};
</script>
